
import { defineComponent, watch, ref, onMounted } from "vue";
import { useRouter, onBeforeRouteUpdate } from "vue-router";
import { microWait } from "@/lib/shared";
import { consts } from "../services/Models";

export default defineComponent({
  name: "Dialog",
  props: {
    isShow: { type: Boolean },
    isHideClose: { type: Boolean },
    title: { type: String },
    isLeftTitle: { type: Boolean },
    isFitSize: { type: Boolean },
    isHideBack: { type: Boolean, default: true },
    isRightTitle: { type: Boolean },
  },
  setup(props, context) {
    const input = ref<HTMLElement>();
    // ダイアログにフォーカスを当てる
    onMounted(async () => {
      await microWait();
      input.value?.focus();
    });
    // ダイアログにフォーカスを当てる(再描画)
    onBeforeRouteUpdate(async () => {
      await microWait();
      input.value?.focus();
    });
    const innerClose = async (newValue: boolean) => {
      if (newValue) {
        document.body.style.overflow = consts.hiddenStyle;
        await microWait();
        input.value?.focus();
      } else {
        document.body.style.overflow = "";
      }
    };
    // 親画面のダイアログ開閉状態をウォッチする
    watch(() => props.isShow, innerClose);
    const close = () => {
      context.emit("update:isShow", false);
      innerClose(false);
    };
    const dummy = () => {};
    const router = useRouter();
    router.beforeEach(() => {
      innerClose(false);
    });
    const back = () => {
      context.emit("back");
    };
    return {
      close,
      dummy,
      back,
      input,
    };
  },
});
